import React from 'react';
import AddPhoneNumber from './AddPhoneNumber';

function AddPhoneNumberContainer(props: Record<string, unknown>) {
  return <AddPhoneNumber {...props} />;
}

export default AddPhoneNumberContainer;
